module.exports = __webpack_public_path__ + "static/media/logout-active.c7685c01.svg";